import * as React from 'react';
import { useFormContext, Controller } from 'react-hook-form';
import { useTranslation } from 'next-i18next';

import { Variable } from '@restworld/utility-types';

import { WizardDateField, WizardSelectField } from '../';
import { WizardStepProps } from '../../worker-application-wizard.types';
import { FormLabelWrapper, PhoneInput, isValidPhoneNumber } from '@restworld/ui-ds-base';
import { useWorkerApplicationCxt } from '../../worker-application-wizard.context';
import { AlreadyUsedLoginHelperText } from './already-used-login-helper-text';

export const WizardThirdStep: React.FunctionComponent<WizardStepProps> = () => {
  const {
    fieldOptions: { sexOptions },
  } = useWorkerApplicationCxt();
  return (
    <div className="flex flex-col gap-4 relative">
      <SexField options={sexOptions} />
      <DateOfBirth />
    </div>
  );
};
export default WizardThirdStep;
const SexField = ({ options }: { options: Variable[] }) => {
  const { t } = useTranslation();
  const { errorsTextMap } = useWorkerApplicationCxt();
  return (
    <WizardSelectField
      placeholder=""
      id={'sex'}
      formLabel={t('onboarding-page:gender')}
      options={options}
      rules={{ required: true }}
      errorMessage={errorsTextMap['sex']}
      testId="sex-options"
      inputTestId="sex-input"
    />
  );
};
const DateOfBirth = () => {
  const { t } = useTranslation();

  return (
    <FormLabelWrapper id="birthdate" label={t('onboarding-page:birth_date')}>
      <WizardDateField id="birthdate" rules={{ required: true }} testId="birth-date-picker-box" />
    </FormLabelWrapper>
  );
};
export const PhoneNumberField = () => {
  const { t } = useTranslation();

  const { control } = useFormContext();
  const { errorsTextMap, conflictFields } = useWorkerApplicationCxt();
  const helperText: string = errorsTextMap['phone_number'];
  // A number that already belongs to an account is the one phone error retyping cannot fix, so
  // it gets the same "log in instead" way out the e-mail field has always had.
  const supportText =
    conflictFields.includes('phone_number') && helperText ? (
      <AlreadyUsedLoginHelperText field="phone_number" />
    ) : (
      helperText
    );
  return (
    <FormLabelWrapper id="phone_number" label={t('onboarding-page:telephone_number')}>
      <Controller
        name="phone_number"
        control={control}
        rules={{ required: t('onboarding-page:invalid_phone_number'), validate: isValidPhoneNumber }}
        render={({ field }) => (
          <PhoneInput
            priorityCountries={['IT', 'FR', 'ES']}
            menuDialogStyles={['min-w-full']}
            variant={helperText ? 'error' : 'primary'}
            supportText={supportText}
            testIds={{
              input: 'wizard-phone-number',
              dropdownBtn: 'wizard-phone-number-dropdown',
              supportText: 'wizard-phone-number-support-text',
              dropdownOptions: 'wizard-phone-number-dropdown-options',
            }}
            {...field}
          />
        )}
      />
    </FormLabelWrapper>
  );
};
